module.exports = __webpack_public_path__ + "media/assets/icons/nav_consultant-b181e4fb493bd8900267ba1de052a6a2.svg";